import { Space } from 'antd';
import React from 'react';

import { SPACING } from '../theme/tokens';
import StatusIcon from './status-icon';

interface SectionLabelProps {
  title: string;
  errors?: string[];
  ok?: boolean;
}

function SectionLabel({
  title,
  errors,
  ok,
}: SectionLabelProps): React.ReactElement {
  const hasErrors = errors !== undefined && errors.length > 0;
  const showOk = ok === true && !hasErrors;

  return (
    <Space size={SPACING.xs} align="center">
      <strong>{title}</strong>
      {hasErrors && <StatusIcon ok={false} />}
      {showOk && <StatusIcon ok={true} />}
    </Space>
  );
}

export default SectionLabel;
